import { WoocommerceProductCategoryOutput } from 'gql/types';

const getProductCategoriesMap = (
  woocommerceCategories: WoocommerceProductCategoryOutput[]
): Record<number, string> => {
  const productCategoriesMap = woocommerceCategories.reduce(
    (categories, category) => {
      return { ...categories, [category.id]: category.name };
    },
    {} as Record<number, string>
  );
  return productCategoriesMap;
};

export { getProductCategoriesMap };
